import React, { useState, useEffect } from 'react';
import { FormControl, Grid, Checkbox, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';
import axios from 'axios';
import { Constants } from '../../endPoints';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const userRegister = `${Constants.userRegister}`;
const listCountry = `${Constants.listCounty}?page=1&limit=100&keyword`;
const checkEmailExists = `${Constants.userExitEmail}`;

export default function Register() {
  const navigate = useHistory();
  const backgroundImageUrl = 'assets/images/bg-02.jpg';
  const [showPassword, setShowPassword] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [emailExistsError, setEmailExistsError] = useState('');
  const [selectedCity, setSelectedCity] = useState(null);

  // Initial form values
  const initialValues = {
    name: '',
    // firstname: '',
    // lastname: '',
    email: '',
    phone: '',
    country_id: '',
    state_id: '',
    city_id: '',
    password: '',
    confirmPassword: '',
    termsAccepted: false,
  };

  // Validation schema
  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    // firstname: Yup.string().required('First Name is required'),
    // lastname: Yup.string().required('Last Name is required'),
    email: Yup.string().email('Invalid email format').required('Email is required'),
    password: Yup.string().required('Password is required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Confirm Password is required'),
    phone: Yup.string().required('Phone is required'),
    // country_id: Yup.string().required('Country is required'),
    // state_id: Yup.string().required('State is required'),
    // city_id: Yup.string().required('City is required'),
    termsAccepted: Yup.boolean()
      .oneOf([true], 'You must accept the terms and conditions')
      .required('You must accept the terms and conditions'),
  });

  // Fetch countries
  useEffect(() => {
    axios
      .get(listCountry)
      .then((response) => {
        const countries = Array.isArray(response.data.data) ? response.data.data : response.data.data.countries;
        setCountryOptions(
          countries.map((country) => ({
            value: country.id,
            label: country.country,
            code: country.country_code,
            flag: country.country_symbols,
          }))
        );
      })
      .catch((error) => console.error('Error fetching countries:', error));
  }, []);

  // Custom option display for Select component
  const formatOptionLabel = ({ label, flag, code }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img src={flag} alt={code} style={{ width: 20, height: 15, marginRight: 10 }} />
      {label}
    </div>
  );

  // Fetch states based on selected country
  useEffect(() => {
    if (selectedCountry) {
      const listState = `${Constants.getStatecountryById}/${selectedCountry.value}`;
      axios
        .get(listState)
        .then((response) => {
          setStateOptions(
            response.data.data.map((state) => ({
              value: state.id,
              label: state.name,
              code: state.state_code,
            }))
          );
        })
        .catch((error) => console.error('Error fetching states:', error));
    }
  }, [selectedCountry]);

  // Fetch cities based on selected state
  useEffect(() => {
    if (selectedState) {
      const listCity = `${Constants.getCityStateById}/${selectedState.value}`;
      axios
        .get(listCity)
        .then((response) => {
          setCityOptions(response.data.data.map((city) => ({ value: city.id, label: city.name })));
        })
        .catch((error) => console.error('Error fetching cities:', error));
    }
  }, [selectedState]);

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption); // Update selected city
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setEmailExistsError('');
    if (email) {
      // Use POST method to check if email already exists
      axios
        .post(checkEmailExists, { email: email })
        .then((response) => {
          if (response.data.isEmail === 1) {
            setEmailExistsError('Email is already registered.');
          }
        })
        .catch((error) => console.error('Error checking email:', error));
    }
  };

  const handleRegister = (values) => {
    console.log('Submit triggered');
    // Log the form values to the console (for debugging)
    console.log(values);

    // Check if email already exists
    if (emailExistsError) {
      return; // Don't proceed if the email is already registered
    }

    // Create the form data object
    const formData = {
      ...values,
      country_id: selectedCountry?.value, // Ensure `selectedCountry` exists
      state_id: selectedState?.value, // Ensure `selectedState` exists
      city_id: selectedCity ? selectedCity.value : '', // Optional field
    };

    console.log(formData); // Log the data before sending it

    // Call API to register the user
    axios
      .post(userRegister, formData)
      .then((response) => {
        // Assuming registration is successful
        if (response.data.status === 1) {
          setSuccessMessage('User registered successfully!');
          setTimeout(() => {
            navigate.push('/login');
          }, 2000);
          setEmailExistsError('');
        }
      })
      .catch((error) => {
        // Handle any errors
        console.error('Error registering user:', error);
        // Optionally display an error message to the user
      });
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <section className="bgleft relative min-h-screen">
      <div className="mx-auto min-h-screen align-items-center">
        <Grid container columns={12} spacing={0} className="overflow-hidden h-full min-h-screen">
          <Grid
            item
            lg={6}
            sm={12}
            xs={12}
            style={{ backgroundImage: `url(${backgroundImageUrl})` }}
            className="bg-cover bg-right-top table"
          >
            <div className="align-middle table-cell py-10 relative boxlayer">
              <Grid container spacing={3} className="justify-center">
                <Grid item lg={6}>
                  <div className="text-center relative z-[1]">
                    <img src="assets/images/logo.svg" className="mx-auto h-20" alt="logo" />
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item lg={6} sm={12} xs={12} className="table">
            <div className="align-middle table-cell pt-24 pb-10 px-6">
              <Grid container spacing={3} className="justify-center">
                <Grid item xl={10} lg={10} md={8} xs={12}>
                  <h2 className="mb-8 text-4xl font-semibold text-center headningfont">Create Account</h2>
                  {successMessage && (
                    <div className="bg-green-100 text-green-800 p-4 mb-4 rounded">
                      {successMessage}
                    </div>
                  )}
                  <div>
                  </div>
                  <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleRegister}>
                    {({ handleSubmit }) => (
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault(); // Prevent default form submission
                          handleSubmit(); // Trigger Formik's submit handler
                        }}
                        className="form-profile"
                      >
                        <Grid container spacing={3}>
                          {/* <Grid item lg={6} md={6} xs={12}>
                            <Field name="firstname">
                              {({ field }) => (
                                <TextField label="First Name" variant="outlined" className="w-full rounded-lg" {...field} />
                              )}
                            </Field>
                            <ErrorMessage name="firstname" component="div" className="text-red-600" />
                          </Grid>
                          <Grid item lg={6} md={6} xs={12}>
                            <Field name="lastname">
                              {({ field }) => (
                                <TextField label="Last Name" variant="outlined" className="w-full rounded-lg" {...field} />
                              )}
                            </Field>
                            <ErrorMessage name="lastname" component="div" className="text-red-600" />
                          </Grid> */}
                          <Grid item lg={12} md={12} xs={12}>
                            <Field name="name">
                              {({ field }) => (
                                <TextField label="Name" variant="outlined" className="w-full rounded-lg" {...field} />
                              )}
                            </Field>
                            <ErrorMessage name="name" component="div" className="text-red-600" />
                          </Grid>
                          <Grid item lg={6} md={6} xs={6}>
                            <Field name="email">
                              {({ field }) => (
                                <TextField
                                  label="Email"
                                  variant="outlined"
                                  className="w-full rounded-lg"
                                  {...field}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    handleEmailChange(e);
                                  }}
                                />
                              )}
                            </Field>
                            <ErrorMessage name="email" component="div" className="text-red-600" />
                            {emailExistsError && (
                              <div className="bg-red-100 text-red-600 p-4 mb-4 rounded">{emailExistsError}</div>
                            )}
                          </Grid>

                          <Grid item lg={6} md={6} xs={12}>
                            <Field name="phone">
                              {({ field }) => (
                                <TextField label="Phone" variant="outlined" className="w-full rounded-lg" {...field} />
                              )}
                            </Field>
                            <ErrorMessage name="phone" component="div" className="text-red-600" />
                          </Grid>

                          {/* Country Selection */}
                          <Grid item lg={6} md={6} xs={12}>
                            <Select
                              options={countryOptions}
                              value={selectedCountry}
                              onChange={handleCountryChange}
                              placeholder="Select Country"
                              getOptionLabel={formatOptionLabel}
                              className="w-full rounded-lg"
                            />
                            <ErrorMessage name="country_id" component="div" className="text-red-600" />
                          </Grid>

                          {/* State Selection */}
                          <Grid item lg={6} md={6} xs={12}>
                            <Select
                              options={stateOptions}
                              value={selectedState}
                              onChange={handleStateChange}
                              placeholder="Select State"
                              className="w-full rounded-lg"
                            />
                            <ErrorMessage name="state_id" component="div" className="text-red-600" />
                          </Grid>

                          {/* City Selection */}
                          <Grid item lg={12} md={12} xs={12}>
                            <Select
                              options={cityOptions}
                              value={selectedCity}
                              onChange={handleCityChange}
                              placeholder="Select City"
                              className="w-full rounded-lg"
                            />
                            <ErrorMessage name="city_id" component="div" className="text-red-600" />
                          </Grid>

                          {/* Password Fields */}
                          <Grid item lg={6} md={6} xs={12}>
                            <Field name="password">
                              {({ field }) => (
                                <FormControl fullWidth variant="outlined" className="mb-4">
                                  <InputLabel htmlFor="password">Password</InputLabel>
                                  <OutlinedInput
                                    id="password"
                                    name="password"
                                    type={showPassword ? 'text' : 'password'}
                                    {...field} // Spread the field props here
                                    label="Password"
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton onClick={handleClickShowPassword} edge="end">
                                          {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              )}
                            </Field>
                            <ErrorMessage name="password" component="div" className="text-red-600" />
                          </Grid>

                          <Grid item lg={6} md={6} xs={12}>
                            <Field name="confirmPassword">
                              {({ field }) => (
                                <FormControl fullWidth variant="outlined" className="mb-4">
                                  <InputLabel htmlFor="confirmPassword">Confirm Password</InputLabel>
                                  <OutlinedInput
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    type={showPassword ? 'text' : 'password'}
                                    {...field} // Spread the field props here
                                    label="Confirm Password"
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton onClick={handleClickShowPassword} edge="end">
                                          {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              )}
                            </Field>
                            <ErrorMessage name="confirmPassword" component="div" className="text-red-600" />
                          </Grid>

                          <Grid item lg={12} md={12} xs={12}>
                            <label className="block mb-2">
                              <Field type="checkbox" name="termsAccepted" /> I accept the{' '}
                              <Link to="/terms" className="text-blue-500">Terms and Conditions</Link>
                            </label>
                            <ErrorMessage name="termsAccepted" component="div" className="text-red-600" />
                          </Grid>

                          <Grid item lg={12} md={12} xs={12}>
                            <div className="mb-5 text-center">
                              <button
                                type="submit"
                                className="min-w-60 h-[54px] shadow-0 bg-[#A27800] rounded-full text-white font-semibold hover:bg-black transition-all"
                              >
                                Create Account
                              </button>
                            </div>
                            <div className='mt-10 text-center'>
                              <p className='mb-4'>Already have account?</p>
                              <Link to="/login" className='min-w-60 inline-block text-center leading-[54px] h-[54px] shadow-0 bg-[#A27800] rounded-full text-white font-semibold hover:bg-black transition-all'>Login</Link>
                            </div>
                          </Grid>

                        </Grid>
                      </Form>
                    )}
                  </Formik>
                  <div className='text-center mt-5'>
                    <span className='text-sm'>
                      Already have an account? <Link to='/login' className='text-primary'>Login</Link>
                    </span>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
}
